'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageAddController = function () {
  function ImageAddController(ImagesDataProvider, $state, Upload, $timeout, API_URL, APPLICATION_URL) {
    "ngInject";

    (0, _classCallCheck3.default)(this, ImageAddController);
    this.image = {};
    this.Upload = Upload;
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.$timeout = $timeout;
    this.API_URL = API_URL;
    this.APPLICATION_URL = APPLICATION_URL;
    this.existRecord = 0;
    var vm = this;
    ImagesDataProvider.loadCategoriesNoLimit().then(function (result) {
      vm.mainCategories = result;
    });
  }

  (0, _createClass3.default)(ImageAddController, [{
    key: 'onvertToSlug',
    value: function onvertToSlug(text) {
      return text.toString().normalize('NFKD') // Bryt ner bokstäver med diakritiska tecken
      .replace(/[\u0300-\u036f]/g, '') // Ta bort diakritiska tecken (accents)
      .toLowerCase().replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/æ/g, 'ae').replace(/ø/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
    }
  }, {
    key: 'saveData',
    value: function saveData(form) {
      var vm = this;
      if (!form) {
        return false;
      }
      vm.__loading = true;
      if (vm.image.name) vm.image.slug = vm.onvertToSlug(vm.image.name);
      var file = vm.image.img;

      var data = {};
      data.name = vm.image.name;
      data.slug = vm.onvertToSlug(vm.image.name);
      data.image_category_id = vm.image.image_category_id;
      data.filename = new Date().valueOf() + file.name;
      data.file = file;

      var chkData = { name: data.name, slug: data.slug };

      vm.ImagesDataProvider.checkRecordExist(chkData).then(function (res) {
        if (res.exist == 0) {
          file.upload = vm.Upload.upload({
            url: vm.APPLICATION_URL + '/api/upload',
            method: 'POST',
            data: { 'image': file, 'max-w': '1200', 'max-h': '600' }
          });
          file.upload.then(function (response) {
            data.filename = new Date().valueOf() + file.name;
            data.response = response.data;
            data.mime_type = file.type;
            vm.ImagesDataProvider.saveImageData(data).then(function (response) {
              vm.$timeout(function () {
                vm.$state.go('app.images');
              }, 5000);
            });
          }, function (response) {
            if (response.status > 0) alert(response.status + ': ' + response.data);
            vm.__loading = false;
          });
        } else {
          vm.existRecord = 1;
          vm.__loading = false;
        }
      });
    }
  }, {
    key: 'change',
    value: function change(file) {
      this.image.name = file.name.replace(/\.[^/.]+$/, "");
    }
  }]);
  return ImageAddController;
}();

// WEBPACK FOOTER //


exports.default = ImageAddController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/images/components/add/controller.js
 **/